<template>
  <div>
    <b-row>
      <b-col sm="12">
        <h4 class="mb-0"><translate>Mark up rules</translate></h4>
      </b-col>
      <b-col sm="12">
        <b-table-simple responsive small>
          <b-thead>
            <b-tr>
              <b-th v-translate>Hotel stars</b-th>
              <b-th v-translate>Commission/room/package (%)Percentage</b-th>
              <b-th v-translate>Commission/room/package</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="stars in order" :key="'fee' + stars">
              <b-td>
                {{ stars ? (stars + '*') : $gettext('No classification')}}
              </b-td>
              <b-td>
                <b-form-group class="mb-0">
                  <b-input
                  type="number"
                  size="sm" />
                </b-form-group>
              </b-td>
              <b-td>
                <b-form-group class="mb-0">
                  <b-input
                  type="number"
                  size="sm" />
                </b-form-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      order: [0, 1, 2, 3, 4, 5]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
